/**
 * @author Nagarjuna Naidu <nagarjuna.naidu@siera.ai>
 *  SIERA DASHBOARD ACCOUNT ACTION TYPES
 */

export const accountTypes = {
  //  1. LIST ACCOUNT ACTION TYPE: FOR LIST ACCOUNTS
  LIST_ACCOUNT: "LIST_ACCOUNT",
};
